module.exports = __webpack_public_path__ + "img/ioms_logo_hero.35f01d84.svg";